export default __webpack_public_path__ + "static/media/auth-back.0b0f0c2e.jpg";